export default "__VITE_ASSET__CabCXXfn__"